if (!customElements.get("fourpaw-accessory-sticky-atc")) {
  customElements.define(
    "fourpaw-accessory-sticky-atc",
    class FourPawAccessoryStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sticky = this.querySelector("[data-accessory-sticky]");
        this.button = this.querySelector("[data-accessory-sticky-button]");
        this.optionsNode = this.querySelector("[data-accessory-sticky-options]");
        this.priceNode = this.querySelector("[data-accessory-sticky-price]");
        this.mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
        this.mainButton = this.mainForm?.querySelector('button[name="add"]');
        this.variantInput = this.mainForm?.querySelector('input[name="id"]');
        this.variants = this.readJson("[data-accessory-sticky-variants]");

        if (!this.sticky || !this.button || !this.mainForm || !this.mainButton) return;

        this.onVariantChange = this.onVariantChange.bind(this);
        this.onOfferChange = this.onOfferChange.bind(this);
        this.onPositionChange = this.onPositionChange.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);

        document.addEventListener("simple-variant-picker:variantChange", this.onVariantChange);
        document.addEventListener("variant:change", this.onVariantChange);
        document.addEventListener("quantity_break:changed", this.onOfferChange);
        this.mainForm.addEventListener("change", this.onOfferChange);
        document.addEventListener("cart:open", this.onPositionChange);
        document.addEventListener("cart-drawer:open", this.onPositionChange);
        document.addEventListener("cartDrawerOpened", this.onPositionChange);
        window.addEventListener("scroll", this.onPositionChange, { passive: true });
        window.addEventListener("resize", this.onPositionChange);
        this.button.addEventListener("click", this.onButtonClick);

        this.syncFromForm();
        this.onPositionChange();
      }

      disconnectedCallback() {
        document.removeEventListener("simple-variant-picker:variantChange", this.onVariantChange);
        document.removeEventListener("variant:change", this.onVariantChange);
        document.removeEventListener("quantity_break:changed", this.onOfferChange);
        this.mainForm?.removeEventListener("change", this.onOfferChange);
        document.removeEventListener("cart:open", this.onPositionChange);
        document.removeEventListener("cart-drawer:open", this.onPositionChange);
        document.removeEventListener("cartDrawerOpened", this.onPositionChange);
        window.removeEventListener("scroll", this.onPositionChange);
        window.removeEventListener("resize", this.onPositionChange);
        this.button?.removeEventListener("click", this.onButtonClick);
        if (this.positionFrame) window.cancelAnimationFrame(this.positionFrame);
        if (this.offerFrame) window.cancelAnimationFrame(this.offerFrame);
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || "[]");
        } catch (_error) {
          return [];
        }
      }

      onVariantChange(event) {
        const variant = event.detail?.variant;
        if (variant) this.currentVariant = variant;
        this.onOfferChange();
      }

      onOfferChange() {
        if (this.offerFrame) window.cancelAnimationFrame(this.offerFrame);
        this.offerFrame = window.requestAnimationFrame(() => {
          this.offerFrame = null;
          this.syncFromForm();
        });
      }

      syncFromForm() {
        this.variantInput = this.mainForm.querySelector('input[name="id"]');
        const variantId = Number(this.variantInput?.value || 0);
        const variant = this.variants.find((item) => Number(item.id) === variantId) || this.currentVariant || this.variants[0];
        if (variant) this.syncVariant(variant);
      }

      syncVariant(variant) {
        this.currentVariant = variant;
        const scope = this.mainForm.closest(".shopify-section") || document;
        const offer = scope.querySelector(".quantity-break-input:checked");
        const quantity = Math.max(1, Number(offer?.dataset.optionQuantity || offer?.value || this.mainForm.querySelector('input[name="quantity"]')?.value || 1));
        const selectedPrice = Number(offer?.dataset.price);
        const total = offer && Number.isFinite(selectedPrice) ? selectedPrice : Number(variant.price || 0) * quantity;
        if (this.optionsNode) this.optionsNode.textContent = `${quantity} × ${(variant.options || []).filter(Boolean).join(" · ")}`;
        if (this.priceNode) this.priceNode.textContent = this.formatMoney(total);
        this.button.disabled = !variant.available;
      }

      formatMoney(cents) {
        if (typeof window.Elixir_FormatMoney === "function") return window.Elixir_FormatMoney(cents);
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
        return (cents / 100).toFixed(2);
      }

      onButtonClick() {
        if (!this.button.disabled && !this.mainButton.disabled) this.mainButton.click();
      }

      onPositionChange() {
        if (this.positionFrame) return;
        this.positionFrame = window.requestAnimationFrame(() => {
          this.positionFrame = null;
          this.syncVisibility();
        });
      }

      syncVisibility() {
        const footer = document.querySelector("footer");
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const buttonRect = this.mainButton.getBoundingClientRect();
        const buttonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
        const cartDrawer = document.querySelector("cart-drawer, #CartDrawer, #sidebar-cart, .cart-drawer");
        const cartOpen = cartDrawer && (
          cartDrawer.hasAttribute("open") ||
          cartDrawer.classList.contains("active") ||
          cartDrawer.classList.contains("is-open") ||
          cartDrawer.classList.contains("drawer--is-open") ||
          cartDrawer.getAttribute("aria-hidden") === "false"
        );
        const threshold = Math.min(240, window.innerHeight * 0.25);
        const visible = window.scrollY >= threshold && !buttonVisible && !footerVisible && !cartOpen;

        this.sticky.classList.toggle("is-visible", visible);
        this.sticky.setAttribute("aria-hidden", visible ? "false" : "true");
        this.sticky.inert = !visible;
      }
    },
  );
}
